import { apiClient } from '@/lib/api'
import type { StandardResponse, PaginatedStandardResponse, PaginationInfo } from '@/types/api-response'
import { extractData, extractPaginatedData } from '@/types/api-response'
import type {
  BillingCycleDiscountListDto,
  BillingCycleDiscountDetailDto,
  CreateBillingCycleDiscountRequest,
  UpdateBillingCycleDiscountRequest,
  BillingCycleDiscountFilters,
} from '@/types/billing-cycle-discount'

export const adminBillingCycleDiscountService = {
  async getDiscounts(
    filters: BillingCycleDiscountFilters
  ): Promise<{ data: BillingCycleDiscountListDto[]; pagination: PaginationInfo }> {
    const params = new URLSearchParams()
    if (filters.isActive !== undefined) params.append('isActive', filters.isActive.toString())
    if (filters.currency) params.append('currency', filters.currency)
    params.append('page', (filters.page ?? 1).toString())
    params.append('limit', (filters.limit ?? 20).toString())

    const response = await apiClient.get<PaginatedStandardResponse<BillingCycleDiscountListDto>>(
      `/api/v1/admin/billing-cycle-discounts?${params.toString()}`
    )
    return extractPaginatedData(response.data)
  },

  async getDiscountById(id: string): Promise<BillingCycleDiscountDetailDto> {
    const response = await apiClient.get<StandardResponse<BillingCycleDiscountDetailDto>>(
      `/api/v1/admin/billing-cycle-discounts/${id}`
    )
    return extractData(response.data)
  },

  async createDiscount(data: CreateBillingCycleDiscountRequest): Promise<BillingCycleDiscountDetailDto> {
    const response = await apiClient.post<StandardResponse<BillingCycleDiscountDetailDto>>(
      '/api/v1/admin/billing-cycle-discounts',
      data
    )
    return extractData(response.data)
  },

  async updateDiscount(id: string, data: UpdateBillingCycleDiscountRequest): Promise<BillingCycleDiscountDetailDto> {
    const response = await apiClient.put<StandardResponse<BillingCycleDiscountDetailDto>>(
      `/api/v1/admin/billing-cycle-discounts/${id}`,
      data
    )
    return extractData(response.data)
  },

  async deleteDiscount(id: string): Promise<void> {
    await apiClient.delete(`/api/v1/admin/billing-cycle-discounts/${id}`)
  },
}
